<template>
  <v-container fluid grid-list-lg>
    <v-layout column wrap>
      <v-layout row wrap align-center justify-center>
        <v-flex md8 xs12 class="mx-2 mt-4">
          <v-select
            label="Select a chat room"
            v-model="selectedRoomId"
            :items="formattedRooms"
            item-text="name"
            item-value="id"
            @change="onRoomChange"
          ></v-select>
        </v-flex>
        <v-flex md8 class="mx-2">
          <div class="message-container">
            <div
              v-for="message in nonEmptyMessages"
              :key="message.id"
              :class="{
                'text-left': message.sender_id === 0,
                'text-right': message.sender_id !== 0,
                deleted: message.status === 'deleted',
              }"
            >
              <div v-if="message.sender_id === 0" class="message" v-html="parseMarkdown(message.content)"></div>
              <div v-if="message.sender_id !== 0" class="message">{{ message.content }}</div>
            </div>
          </div>
        </v-flex>
        <v-flex md8 class="mx-2 mt-4">
          <v-btn color="primary" @click="nextRoom">Next Room</v-btn>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import marked from 'marked';
import moment from 'moment';
import { Vue } from 'vue-property-decorator';
import store from '../../store';
import chatService from '../../services/chat';
export default Vue.extend({
  store,
  data: () => ({
    selectedRoomId: null,
    rooms: [],
    messages: [],
  }),
  computed: {
    formattedRooms() {
      return this.rooms.map((room) => ({
        id: room.id,
        name: `${this.dateFormat(room.last_message_at)}: ${room.name} (${this.formattedNumber(
          room.message_count
        )} messages)`,
      }));
    },
    nonEmptyMessages() {
      return this.messages.filter((message) => message.content.trim() !== '');
    },
  },
  watch: {},
  created() {},
  mounted() {
    chatService.fetchChatRoom().then((rooms) => {
      this.rooms = rooms || [];
      this.nextRoom();
    });
  },
  methods: {
    onRoomChange() {
      chatService.fetchChatRoomMessage(this.selectedRoomId).then((messages) => {
        this.messages = messages || [];
      });
    },
    formattedNumber(n) {
      return new Intl.NumberFormat('th-TH').format(n);
    },
    nextRoom() {
      if (this.rooms.length === 0) return;

      const selectedIndex = this.rooms.map((room) => room.id).indexOf(this.selectedRoomId);
      if (this.rooms.length > selectedIndex + 1) {
        this.selectedRoomId = this.rooms[selectedIndex + 1].id;
        this.onRoomChange();
      } else {
        this.selectedRoomId = this.rooms[0].id;
        this.onRoomChange();
      }
    },
    parseMarkdown(md) {
      return marked.parse(md);
    },
    dateFormat(date) {
      return moment(date).format('DD MMM YYYY');
    },
  },
});
</script>

<style>
.message p {
  margin-bottom: 8px;
}
</style>

<style scoped>
.message-container {
  background: #eeeeee;
  padding: 20px 14px;
  border-radius: 12px;
  height: 60vh;
  overflow-y: auto;
}
.message {
  border-radius: 12px;
  padding: 6px 11px;
  display: inline-block;
  margin-bottom: 6px;
}
.text-right .message {
  margin-left: 36px;
  background: #35a5e5;
  color: white;
}
.text-left .message {
  margin-right: 36px;
  background: #efefef;
  margin-bottom: 12px;
}
.deleted .message {
  background: #ffcccc;
  color: #ff0000;
}
</style>
